import React, { FC } from "react"
import { useSelector } from "react-redux"
import _ from "lodash"

import {
  getSectionFieldNames,
  countIncompleteRequiredFields,
  getSectionChat,
  countChangedFields,
} from "@/onboarding/features/product/selectors"
import { ReservedSections } from "@/onboarding/features/product/models/Product"

import SectionHolder from "./shared/SectionHolder"
import Content from "./additional_details/Content"
import Edit from "./additional_details/Edit"

const AdditionalDetails: FC = () => {
  const fieldNames = useSelector(getSectionFieldNames.additionalDetails)
  const incompleteFieldCount = useSelector(countIncompleteRequiredFields(...fieldNames))
  const proposedChangesCount = useSelector(countChangedFields(...fieldNames))
  const sectionChat = useSelector(getSectionChat(_.snakeCase("additionalDetails")))

  return (
    <SectionHolder
      title="Additional Details and Restrictions"
      name={ReservedSections.ADDITIONAL_DETAILS}
      editComponent={Edit}
      editMethod="inline"
      importableFields={fieldNames}
      incompleteRequiredFieldCount={incompleteFieldCount}
      proposedChangesCount={proposedChangesCount}
      chat={sectionChat}
    >
      <Content />
    </SectionHolder>
  )
}

export default AdditionalDetails
